import truck from "./media/truck.png";
import tempo from "./media/tempo.png";
import india from "./media/india.png";
import scooter from "./media/scooter.png";
import woman from "./media/woman.png";
import parsal from "./media/parsal.png";
import parsal3 from "./media/parsal3.png";
import playstore from "./media/playstore.png";
import appstore from "./media/appstore.png";
import logo from "./media/logo.png";
import arrow_down from "./media/arrow-down.png";
import hero_bg from "./media/hero_bg.png";
import work1 from "./media/work1.png";
import work2 from "./media/work2.png";
import work3 from "./media/work3.png";
import test1 from "./media/test1.png";
import test2 from "./media/test2.png";
import test3 from "./media/test3.png";
import map from "./media/map.png";
import plot1 from "./media/plot1.png";
import plot2 from "./media/plot2.png";
import f_logo from "./media/f_logo.png";
import ellipse4 from "./media/ellipse4.png";
import download from "./media/download.png";
import download2 from "./media/download2.png";
import burger from "./media/burgerMenu.png";
import close from "./media/close.png";
import frame1 from "./media/frame1.png";
import frame10 from "./media/frame10.png";
import frame11 from "./media/frame11.png";
import frame12 from "./media/frame12.png";
import frame13 from "./media/frame13.png";
import frame14 from "./media/frame14.png";
import social1 from "./media/social1.png";
import social2 from "./media/social2.png";
import social3 from "./media/social3.png";
import ship1 from "./media/ship1.png";
import ship2 from "./media/ship2.png";
import star1 from "./media/star1.png";
import about from "./media/about.png";
import delivery from "./media/delivery.png";
import headset from "./media/headset.png";
import home from "./media/home.png";
import rupee from "./media/rupee.png";
import cross from "./media/cross.png";
import bikeride from "./media/bike_ride.png";

export const parsal_img = {
  truck: truck,
  tempo: tempo,
  india: india,
  scooter: scooter,
  woman: woman,
  parsal: parsal,
  parsal3: parsal3,
  playstore: playstore,
  appstore: appstore,
  logo: logo,
  arrow_down: arrow_down,
  hero_bg: hero_bg,
  work1: work1,
  work2: work2,
  work3: work3,
  test1: test1,
  test2: test2,
  test3: test3,
  map: map,
  plot1: plot1,
  plot2: plot2,
  f_logo: f_logo,
  social1: social1,
  social2: social2,
  social3: social3,
  ellipse4: ellipse4,
  download: download,
  download2: download2,
  burger: burger,
  close: close,
  frame1: frame1,
  frame10: frame10,
  frame11: frame11,
  frame12: frame12,
  frame13: frame13,
  frame14: frame14,
  ship1: ship1,
  ship2: ship2,
  star1: star1,
  about: about,
  delivery: delivery,
  headset: headset,
  home: home,
  rupee: rupee,
  cross: cross,
  bikeride: bikeride,
};
